import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "seq-notice__icon" }
const _hoisted_2 = { class: "svg-icon svg-icon-2x" }
const _hoisted_3 = { class: "seq-notice__content" }
const _hoisted_4 = {
  key: 0,
  class: "seq-notice__title"
}
const _hoisted_5 = { class: "seq-notice__body" }
const _hoisted_6 = {
  key: 1,
  class: "seq-notice__actions"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")

  return (_openBlock(), _createBlock("div", {
    class: ["seq-notice", `seq-notice--${_ctx.variant}`]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("span", _hoisted_2, [
        _createVNode(_component_inline_svg, { src: _ctx.resolvedIcon }, null, 8, ["src"])
      ])
    ]),
    _createVNode("div", _hoisted_3, [
      (_ctx.title)
        ? (_openBlock(), _createBlock("h4", _hoisted_4, _toDisplayString(_ctx.title), 1))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_5, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      (_ctx.buttons.length || _ctx.$slots.actions)
        ? (_openBlock(), _createBlock("div", _hoisted_6, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.buttons, (button, index) => {
              return (_openBlock(), _createBlock(_Fragment, { key: index }, [
                (button.href)
                  ? (_openBlock(), _createBlock("a", {
                      key: 0,
                      href: button.href,
                      target: button.target || undefined,
                      class: ["btn", _ctx.buttonClass(button)],
                      onClick: ($event: any) => (_ctx.onButtonClick(button, index))
                    }, _toDisplayString(button.label), 11, ["href", "target", "onClick"]))
                  : (_openBlock(), _createBlock("button", {
                      key: 1,
                      type: "button",
                      class: ["btn", _ctx.buttonClass(button)],
                      onClick: ($event: any) => (_ctx.onButtonClick(button, index))
                    }, _toDisplayString(button.label), 11, ["onClick"]))
              ], 64))
            }), 128)),
            _renderSlot(_ctx.$slots, "actions")
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}